import axios from "axios";
import { identity, both, pathEq } from "ramda";
import store from '@/store'
import router from '@/router'
const baseURL = `${process.env.VUE_APP_API_BASE_URL}`
const _axios = axios.create({ baseURL })

_axios.addBearerToken = function(firebaseUserToken) {
  this.defaults.headers.common = {
    'Authorization': `Bearer ${firebaseUserToken}`
  }
}

_axios.clearBearerToken = function() {
  this.defaults.headers.common = {}
}

const isSessionExpireError =  both(
  pathEq([ "request", "status" ], 401),
  pathEq([ "response", "data", "detail"], 'Session expired')
)

// function sleep(ms) {
//   return new Promise(resolve => setTimeout(resolve, ms));
// }

_axios.interceptors.response.use(identity, function (error) {
  const originalConfig = error.config;
  // Do something with response error
  if(isSessionExpireError(error) && !originalConfig._retry) {
    // store.dispatch('auth/sessionExpired')
    // router.push({ name: 'Login' })
    originalConfig._retry = true;
    return store.dispatch('auth/refreshToken').then(async (newUserToken) => {
      error.config.headers = {
        'Authorization': `Bearer ${newUserToken}`
      }
      // await sleep(20000);
      return _axios(error.config);
    })
    .catch((er) => {
      return Promise.reject(er);
    });
  }
  return Promise.reject(error);
});

export default _axios;
